import { useEffect, useState } from "react";
import { Box, Chip, CircularProgress, Typography } from "@mui/material";
import { getGazetteNotices } from "../../data/request";
import { getDateDisplay } from "../../data/utilities";
import { BORDER_GREY, STATUS_AMBER, STATUS_RED, TEXT_SECONDARY } from "../colors";

type GazetteNotice = {
  id: string;
  published_date: string;
  notice_type: string;
  severity: "red" | "amber";
  citation: string;
  url: string;
};

// Insolvency/petition signals from The Gazette - a separate, often earlier
// warning than Filing History, since a winding-up petition is Gazetted
// immediately but may not reach Companies House for weeks. Its own Pro tab
// (gated by the parent, same as Financials/Shareholders/etc) rather than a
// block on Overview.
export const GazetteTimeline = (props: { companyNo?: string }) => {
  const { companyNo } = props;
  const [notices, setNotices] = useState<GazetteNotice[]>();

  useEffect(() => {
    if (!companyNo) {
      return;
    }
    getGazetteNotices(companyNo).then((doc) => setNotices(doc?.notices ?? []));
  }, [companyNo]);

  return (
    <Box style={{ padding: 20 }}>
      {notices === undefined ? (
        <Box style={{ display: "flex", justifyContent: "center", padding: 20 }}>
          <CircularProgress size={24} color="primary" />
        </Box>
      ) : notices.length === 0 ? (
        <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
          No Gazette insolvency notices recorded for this company.
        </Typography>
      ) : (
        <Box style={{ position: "relative", paddingLeft: 28 }}>
          <Box
            style={{
              position: "absolute",
              left: 5,
              top: 6,
              bottom: 6,
              width: 2,
              backgroundColor: BORDER_GREY,
            }}
          />
          {notices.map((notice, index) => (
            <Box key={notice.id} style={{ position: "relative", marginBottom: index === notices.length - 1 ? 0 : 20 }}>
              <Box
                style={{
                  position: "absolute",
                  left: -28,
                  top: 3,
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: notice.severity === "red" ? STATUS_RED : STATUS_AMBER,
                  border: `2px solid ${notice.severity === "red" ? STATUS_RED : STATUS_AMBER}`,
                }}
              />
              <Box style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Chip
                  label={notice.notice_type}
                  size="small"
                  style={{
                    backgroundColor: notice.severity === "red" ? STATUS_RED : STATUS_AMBER,
                    color: "white",
                  }}
                />
                <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
                  {getDateDisplay(notice.published_date)}
                </Typography>
              </Box>
              <Typography variant="caption" style={{ color: TEXT_SECONDARY, display: "block", marginTop: 4 }}>
                {notice.citation}
              </Typography>
              <a href={notice.url} target="_blank" rel="noreferrer" style={{ fontSize: 13 }}>
                View full notice on The Gazette
              </a>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default GazetteTimeline;
